import type { ReactNode } from "react";
import { Icon } from "../icons/Icon";

/** The one quiet line on a page the viewer may read but not change (the polish round, 2026-10-31; DECISIONS "The polish round…"): a lock and
 *  "Read only: administrators change this." (`object` names the thing: "… this form."; `children` replace the words after "Read only: ", as
 *  Legal & data's "the owner downloads, exports and deletes."). A note for screen readers, read once, never an alert. Who sees it is the
 *  screen's choice: never someone who holds the right. */
export function ReadOnlyNote({ object, children }: { object?: string; children?: ReactNode }) {
  const words = children ?? `administrators change this${object ? ` ${object}` : ""}.`;
  return (
    <p className="ob-readonly" role="note">
      <Icon name="lock" size="sm" />
      <span className="ob-readonly__text">Read only: {words}</span>
    </p>
  );
}
